<template>
  <div class="left cadfm-flexitem-fixed scrollbars">
    <div class="Tabs">
      <action-panel>
        <action-bar>
          <b-navbar-nav>
            <action-button  @click="toggleLeftPanel"  icon="hide" bold :text="lang.button_Hide" :title="lang.button_Hide" :disabled="false"/>


          </b-navbar-nav>
        </action-bar>
        <action-content>
            <b-tabs  card>

            <b-tab :title="lang.Content.tab_Category"  :title-link-class="textColors" :title-item-class="textColors" active >

              <TreeComponent :action="false"  :iscategory="editCategories"  class="treecomponent" :lang="lang.Content.Tree"></TreeComponent>
            </b-tab>

          </b-tabs>



        </action-content>
      </action-panel>

    </div>
  </div>
</template>


<script>

//import Right from '@/components/PartManager/Right/Right'
import { mapGetters } from 'vuex'
import ActionBar from '@/components/shared/ActionBar'
import ActionButton from '@/components/shared/ActionButton'
import ActionContent from '@/components/shared/ActionContent'
import ActionPanel from '@/components/shared/ActionPanel'
import TreeComponent from "@/components/shared/TreeComponent"

export default {
  name: 'Left',
  components:{
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    TreeComponent
  },
  props:{
    lang: Object
  },
  data () {
    return {
       editCategories:false,
    }
  },
  computed: {
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    }

  },

  created() {

  },
  updated() {


  },
  methods: {
    toggleLeftPanel(){
      
      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;
      
    }
  }
}
</script>


<style scoped>
.left{
  border-right: 1px solid #666;

}

.center-content{
  text-align: center;
}
img {
  max-width:200px;
  max-height:200px;
}
</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/Properties/Left/Left.vue